import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { sortByMonthChartData } from "../../../utils/functionUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ServiceRequestReport = ({
  chartReportCountSuccess,
  reportName,
  getBgColor,
}) => {
  const options = {
    plugins: {
      title: {
        display: true,
        text: reportName,
        align: 'start',
        font: {
          size: 20,
        },
        padding: {
          // bottom: -30
        }
      },
      legend: {
        align: 'end',
        position: 'top',
        labels: {
          font: {
            weight: 500,
            color: 'black',
            size: 14,
          }
        }
      },
      datalabels: {
        formatter: function (value, context) {
          // return value > 0 ? value+'%' : null;
        },
        align: "top",
        anchor: "end",
        labels: {
          usePointStyle: true,
          font: {
            weight: 700,
            color: "black",
            size: 14,
          },
        },
      }
    },
    responsive: true,
    scales: {
      x: {
        stacked: false,
        grid: {
          display:false
        }
      },
      y: {
        stacked: false,
        grid: {
          display:false
        }
      },
    },
    // barThickness: 15
  };

const sortServiceRequestReportCount = sortByMonthChartData(chartReportCountSuccess["ServiceRequestReportCount"]);

  const ServiceRequestReportCount = {
    Months: sortServiceRequestReportCount?.map(
      (v) => v?.Month
    ),
    ["Total SR"]: sortServiceRequestReportCount?.map(
      (v) => v?.["Total Service Requests"]
    ),
    ["Accepted SR"]: sortServiceRequestReportCount?.map(
      (v) => v?.["Accepted Service Requests"]
    ),
    ["Cancelled SR"]: sortServiceRequestReportCount?.map(
      (v) => v?.["Canceled Service Requests"]
    ),
    ["Rejected SR"]: sortServiceRequestReportCount?.map(
      (v) => v?.["Rejected Service Requests"]
    ),
  };

  let labelssorting = ServiceRequestReportCount?.Months;

  const sorter = (a, b) => {
    a = a.split("-");
    b = b.split("-");
    if (a[0] !== b[0]) {
      return a[0] - b[0];
    } else {
      return a[1] - b[1];
    }
  };
 const labels = labelssorting //?.sort(sorter);

  let subscriptionLabel = ["Accepted SR", "Cancelled SR", "Rejected SR"];
  // 'Total Service Request',

  let _reportData = [];
  for (let i = 0; i < subscriptionLabel.length; i++) {
    _reportData.push({
      label: subscriptionLabel[i],
      data: ServiceRequestReportCount[subscriptionLabel[i]],
      backgroundColor: getBgColor[i],
      stack: i,
      borderWidth: 1
    });
  }
  
  const reportData = {
    labels,
    datasets: _reportData,
  };

  return (
    <div>
      <Bar options={options} data={reportData} />
    </div>
  );
};

export default ServiceRequestReport;
